interface SectionData {
  title: string
  textContent: string
  textElement: Element
}

export function parseCCDADocument(xmlString: string): SectionData[] {
  const parser = new DOMParser()
  const xmlDoc = parser.parseFromString(xmlString, 'application/xml')

  const parseError = xmlDoc.querySelector('parsererror')
  if (parseError) {
    throw new Error('XML parsing error: ' + parseError.textContent)
  }

  const sections = xmlDoc.querySelectorAll('component section')
  const results: SectionData[] = []

  sections.forEach((section) => {
    const titleElement = section.querySelector('title')
    const textElement = section.querySelector('text')

    if (titleElement && textElement) {
      results.push({
        title: titleElement.textContent?.trim() || '',
        textContent: textElement.innerHTML,
        textElement: textElement,
      })
    }
  })

  return results
}
